@if (isOpen()) {
  <kendo-dialog
    title="{{ 'summarization.meetingPreparation.title' | translate }}"
    (close)="close()"
    [width]="800"
    maxWidth="90%"
    height="95%"
    [style.z-index]="'.k-window, .ui-dialog' | maxZIndex: 99990"
    [maxHeight]="900"
  >
    <div class="flex flex-col h-full gap-2">
      <p class="text-body-1">
        {{
          'summarization.meetingPreparation.subtitle'
            | translate
            | format: entryType() : entryName()
        }}
      </p>

      <kendo-tabstrip class="overflow-hidden flex-grow">
        <kendo-tabstrip-tab
          #summarizationTab
          id="summarization"
          [title]="'summarization.tabs.summarization' | translate"
          [selected]="true"
        >
          <ng-template kendoTabContent>
            <div class="py-2 flex flex-col items-center justify-center h-full">
              @if (summaryText().length) {
                <div
                  class="flex-grow w-full max-h-full overflow-y-auto text-body-2 border border-neutral-40 p-2"
                  [innerHTML]="summaryText() | deAnonymizer | safeHtml"
                ></div>
              } @else if (!loading()) {
                <img
                  class="w-[108px]"
                  [src]="cdn + '/assets/images/empty-container.svg'"
                  [alt]="message.innerText"
                />
                <span #message class="text-caption mt-4">
                  {{ 'summarization.message.noSummary' | translate }}
                </span>
              }
            </div>
          </ng-template>
        </kendo-tabstrip-tab>
      </kendo-tabstrip>
    </div>
    @if (loading()) {
      <maximizer-loader type="legacy"></maximizer-loader>
    }
    <kendo-dialog-actions class="mt-2 justify-between">
      <div class="flex items-center justify-between">
        <div>
          <button
            kendoButton
            themeColor="primary"
            fillMode="flat"
            (click)="copyToClipboard()"
            [disabled]="!summary()"
          >
            <div class="flex items-center">
              <span class="fa-icons icon-light icon-16 icon-copy mr-1"></span>
              {{ 'buttons.copyToClipboard' | translate }}
            </div>
          </button>
        </div>
        <div class="flex flex-row gap-4">
          @if (summary()) {
            <ai-feedback
              [disableOnFeedback]="true"
              [source]="tracker.module"
              [label]="'summarization.feedback' | translate"
            ></ai-feedback>
          }
          <button
            kendoButton
            themeColor="secondary"
            (click)="close()"
            class="uppercase"
          >
            {{ 'buttons.close' | translate }}
          </button>
        </div>
      </div>
    </kendo-dialog-actions>
  </kendo-dialog>
}
